import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../auth/useAuth'
import { areaDoCaminho, type AreaKey } from './areas'
import { areasNavegaveis, ultimaArea } from './acesso'

/** As áreas que o usuário logado alcança, na ordem do catálogo, e a pergunta
 *  `temArea` para os atalhos que levam de uma área a outra. */
export function useAreas(): { areas: AreaKey[]; temArea: (area: AreaKey) => boolean } {
  const { user } = useAuth()
  return useMemo(() => {
    const areas = areasNavegaveis(user)
    return { areas, temArea: (area: AreaKey) => areas.includes(area) }
  }, [user])
}

/** A área cuja navegação a barra lateral mostra. Vem do endereço; em rota neutra,
 *  vale a última área visitada, se ainda for permitida, ou a primeira permitida. */
export function useAreaAtual(): AreaKey | null {
  const { pathname } = useLocation()
  const { areas } = useAreas()
  const doCaminho = areaDoCaminho(pathname)
  if (doCaminho) return areas.includes(doCaminho) ? doCaminho : null
  const ultima = ultimaArea()
  if (ultima && areas.includes(ultima)) return ultima
  return areas[0] ?? null
}
